const helper = {
  findIndexElementInObjArrayByProperty (elementName, value, array) {
    return array.findIndex(item => item[elementName] == value)
  },
  findAndRemoveElementsInObjArrayByProperty (elementName, array) {
    return array.filter(item => !!item[elementName])
  },
  findAndRemoveElementsInObjArrayByProperties (firstElementName, secondElementName, secondvalue, array) {
    return array.filter(item => !!item[firstElementName] && item[secondElementName] != secondvalue)
  },
  findElementInArray (element, array) {
    return array.find(item => item == element)
  },
  findElementInObjArray (elementName, value, array) {
    return array.find(item => item[elementName] == value)
  },
  deepCloneObjArray (array) {
    return JSON.parse(JSON.stringify(array))
  },
  checkIfArrayOrObjEmpty(arrayOrObj){
    var isEmpty = true
    var isArray = Object.prototype.toString.call(arrayOrObj) == "[object Array]"
    var isObj = Object.prototype.toString.call(arrayOrObj) == "[object Object]"
    if((isArray && arrayOrObj.length) || (isObj && Object.keys(arrayOrObj).length)){
      isEmpty = false
    }
    return isEmpty
  },
  removeLocalStorageLogInData(){
    localStorage.removeItem('logInData')
  }
}

export default helper


// WEBPACK FOOTER //
// ./src/Unit/helper.js